import { IpDeviceCollection } from 'app/shared/collections/ip_device_collection.service';
import { Tag } from 'app/shared/collections/tag';
import { getUniqueTags } from 'app/shared/collections/tags/utils';
import { EventRegistry } from '../../events/event_registry';

export const IMS_TYPE__IP_DEVICE_TAG = 'ip_device_tag';

/**
 * A helper collection that contains all of the tags
 * that are assigned to ip devices
 */
export class IpDeviceTagCollection {
    private _tags: { [id: number]: Tag };
    private _onChangeEventRegistry: EventRegistry;

    constructor(ipDeviceCollection: IpDeviceCollection) {
        this._tags = {};
        this._onChangeEventRegistry = new EventRegistry();
        ipDeviceCollection.addOnChangedListener(() => {
            this._tags = getUniqueTags(ipDeviceCollection);
            return this._onChangeEventRegistry.notifyListeners(this._tags);
        });
    }

    addOnChangedListener(listenerFunc, runImmediately = true) {
        const rm = this._onChangeEventRegistry.addEventListener(listenerFunc);
        // callback with the current collection AFTER it has been added to the registry in-case the listener is removed on the first callback
        if (runImmediately) {
            listenerFunc(this._tags);
        }
        return rm;
    }

    getAllSelectableAsArray() {
        return this.getAllAsArray();
    }

    getAllAsArray() {
        return Object.values(this._tags);
    }

    get all() {
        return this._tags;
    }
}
